import { Level } from "./level.model";

export class DeviceRight {
  id: number;
  entityType: DeviceRightType;
  entityId: number;
  name: string | null;

  constructor({
    id,
    entityType,
    entityId,
    name,
  }: {
    id: number;
    entityType: number;
    entityId: number;
    name: string | null;
  }) {
    this.id = id;
    this.entityType = entityType;
    this.entityId = entityId;
    this.name = name;
  }
}

export enum DeviceRightType {
  Level = 1,
  Device = 2,
}

export const getDeviceRights = (
  deviceIds: number[],
  levelIds: number[],
  deviceRights: DeviceRight[],
  levels?: Level[],
) => {
  const newRights = [
    ...levelIds.map((levelId: number) => ({
      entityType: DeviceRightType.Level,
      entityId: levelId,
    })),
    ...deviceIds.map((deviceId: number) => ({
      entityType: DeviceRightType.Device,
      entityId: deviceId,
    })),
  ];

  const modifiedDeviceRights = newRights.map((item) => {
    const matchingObject = deviceRights.find((obj) => {
      return (
        obj.entityId === item.entityId && obj.entityType === item.entityType
      );
    });
    let name = "";
    if (levels) {
      if (item.entityType === DeviceRightType.Level) {
        const level = levels.find((level) => level.id === item.entityId);
        name = level?.name || "";
      } else {
        const device = levels
          .flatMap((level) => level.devices)
          .find((device) => device.id === item.entityId);
        name = device?.name || "";
      }
    }
    return {
      ...item,
      id: matchingObject ? matchingObject.id : 0,
      name,
    };
  });

  return modifiedDeviceRights;
};
